import { Component, type ReactNode } from 'react';
import { RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { m } from '@/lib/i18n';

/** If rendering ever crashes, show a way out instead of a blank page. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error(error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="mx-auto grid min-h-dvh max-w-md place-content-center gap-4 p-6 text-center">
        <h1 className="text-2xl font-bold">{m.crash_title()}</h1>
        <p className="text-muted-foreground">{m.crash_body()}</p>
        <Button size="lg" onClick={() => location.reload()}>
          <RotateCcw /> {m.reload()}
        </Button>
      </div>
    );
  }
}
